import React from 'react';
import './Heeader.css'

const Heeader = () => {
    return (
        <div className="header">
            <h1>Make a top Teachers team </h1>
            <p>A teacher, also called a schoolteacher or formally an educator, is a person who helps students to acquire knowledge, competence or virtue.</p>
            <h1>Total Budget: 100 Million</h1>
        </div>
    );
};

export default Heeader;